module.exports = __webpack_public_path__ + "img/emoji_43.2c16a519.png";